import React from 'react';
import {
  Box, Container, Typography, Grid, Paper, Stack,
} from '@mui/material';
import {
  Storage, DeveloperMode, TrendingUp, Speed, Layers, DataObject,
} from '@mui/icons-material';
import { C, Section } from './theme';

const DividerLine = () => <Box sx={{ width: '100%', height: 2, background: 'rgba(255,255,255,0.1)', my: 0.5 }} />;

const buildCards = [
  {
    id: 1,
    title: 'Persistent data on NVMe SSD; scale horizontally with multiple instances.',
    imageSrc: '/assets/vps-build/image-1.png', // Image slot for when user uploads their image
    icon: <Storage sx={{ fontSize: 44, color: '#2563EB' }} />,
    bgTag: 'NVMe SSD',
    color: '#2563EB',
    lightBg: '#EFF6FF',

  },
  {
    id: 2,
    title: 'Deploy via Docker/ Compose or system packages.',
    imageSrc: '/assets/vps-build/image-2.png', // Image slot
    icon: <DeveloperMode sx={{ fontSize: 44, color: '#10B981' }} />,
    bgTag: 'Docker',
    color: '#10B981',
    lightBg: '#ECFDF5',

  },
  {
    id: 3,
    title: 'Upgrade plans seamlessly for more resources during growth.',
    imageSrc: '/assets/vps-build/image-3.png', // Image slot
    icon: <TrendingUp sx={{ fontSize: 44, color: '#F59E0B' }} />,
    bgTag: 'Scalable',
    color: '#EF4444',
    lightBg: '#FFFBEB',

  },
];

const VpsBuild = () => (
  <Section id="build" sx={{ background: '#FFFFFF', py: { xs: 8, md: 12 }, borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">

      {/* Title Header */}
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography variant="h2" sx={{
          fontWeight: 800,
          fontSize: { xs: '2rem', sm: '2.6rem', md: '3.1rem' },
          color: C.textPrimary,
          letterSpacing: '-0.035em',
          mb: 1.75,
        }}>
          Build your system your way on a VPS
        </Typography>
        <Typography sx={{
          color: C.textSecondary,
          fontSize: { xs: '1rem', md: '1.08rem' },
          maxWidth: 680,
          mx: 'auto',
          lineHeight: 1.6,
        }}>
          Monoliths or micro-services. Your virtual private server, your rules.
        </Typography>
      </Box>

      {/* 3 Columns Grid (MUI v6 Grid size) */}
      <Grid container spacing={{ xs: 4, md: 5 }}>
        {buildCards.map((card) => (
          <Grid size={{ xs: 12, md: 4 }} key={card.id}>
            <Box sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              px: { xs: 2, md: 3 },
            }}>
              {/* Graphic Card / Image Box */}
              <Box sx={{
                width: '100%',
                height: 220,
                borderRadius: '16px',
                background: '#FFFFFF',
                border: `1px solid ${C.border}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3.5,
                boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                transition: 'transform 0.22s, box-shadow 0.22s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.06)',
                },
                position: 'relative',
                overflow: 'hidden',
              }}>
                {/* Check if actual user image exists, else display illustration placeholder */}
                <img
                  src={card.imageSrc}
                  alt={card.title}
                  onError={(e) => { e.target.style.display = 'none'; }}
                  style={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain', display: 'block' }}
                />
                <Box className="illustration-fallback" sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {card.illustration}
                </Box>
              </Box>

              {/* Caption Text */}
              <Typography sx={{
                color: C.textPrimary,
                fontWeight: 700,
                fontSize: { xs: '0.98rem', md: '1.05rem' },
                lineHeight: 1.55,
                maxWidth: 320,
              }}>
                {card.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

    </Container>
  </Section>
);

export default VpsBuild;
